import React, { useState } from 'react';
import { factory } from 'typescript';
import { RootState } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import {
	postDataPage,
	setPageNo,
	setPageSize,
} from '../../../redux/eventsSlice';
import { Tevent } from '../../../type/event';
import { Link } from 'react-router-dom';
import { MonthAsByDate } from '../../../utls/date';
import { MINIO } from '../../../data/data';
import { FiCalendar } from 'react-icons/fi';

interface ScrollItemEventProps {
	keyword: string;
	fix?: boolean;
}

const ScrollItemEvent = (props: ScrollItemEventProps) => {
	const { keyword, fix = factory } = props;
	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const { eventsPage, totalRows, pageNo, pageSize } = useSelector(
		(state: RootState) => state.reducer.events
	);

	const dispatch = useDispatch<any>();

	const getEventList = async (page: number, pageSize: number) => {
		const params = {
			pageNo: 0,
			pageSize: 10,
			sortType: 'DESC',
			filter: [
				{
					key: 'name',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'content',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'content_plain',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'active',
					value: true,
					operation: 'EQUAL',
					conjunction: 'and',
				},
			],
		};
		dispatch(postDataPage(params));
		dispatch(setPageNo(page));
		dispatch(setPageSize(pageSize));
	};

	const handleScroll = async (e: React.UIEvent<HTMLDivElement>) => {
		const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;

		if (
			scrollHeight - scrollTop === clientHeight &&
			!loading &&
			!(totalRows === eventsPage.length)
		) {
			setLoading(true);
			getEventList(pageNo + 1, 10);
			setLoading(false);
		}
	};

	return (
		<>
			<div
				onScroll={handleScroll}
				className={` ${
					!fix ? 'max-h-[calc(100vh-150px)] overflow-auto' : 'mb-[100px]'
				} `}
			>
				{eventsPage.map((item: Tevent, index: number) => {
					const text = item.content_plain || '';
					const plain = text.substring(0, 100);
					const date = new Date(item.startDate);
					const day = date.getDate();
					return (
						<div
							key={index}
							className="flex mb-4"
						>
							<div className="relative bg-gray-50 text-center overflow-hidden max-w-[100px] max-h-[100px] rounded-sm">
								<Link to={`/admin/events/${item.slug}`}>
									<div className="bg-[#171766] absolute px-2 py-1 bottom-0 right-0 text-white text-center rounded-sm">
										<span className="block p-0 m-0 text-[11px]">{day}</span>
										<span className="block p-0 m-0 text-[11px]">
											{MonthAsByDate(item.startDate)}
										</span>
									</div>
									<img
										src={`${MINIO}/${item.thumbnail}`}
										className=""
										alt={item.name}
									/>
								</Link>
							</div>
							<div className="ml-3">
								<Link to={`/admin/events/${item.slug}`}>
									<h2 className="text-[13px] font-medium block">{item.name}</h2>
								</Link>
								<span className="text-[10px] text-gray-400 m-0 p-0 flex items-center">
									<FiCalendar className="mr-2" />
									{new Date(item.createDate).toLocaleDateString()} -{' '}
									{new Date(item.createDate).toLocaleTimeString()}
								</span>
								<p className="text-[11px] text-justify">{plain}...</p>
							</div>
						</div>
					);
				})}
			</div>
		</>
	);
};

export default ScrollItemEvent;
